const Main = {
  DescriptionMinLength: 50,
}

export default Main
